<template>
  <div class="app-container">
    <div class="mapping-table">
      <el-row class="page-buttons">
        <editor-button action="cancel" style="float:right" @click="close" />
        <editor-button
          :icon-only="false"
          action="save"
          style="float:right;margin-right:10px"
          @click="saveSelection()"
        />
      </el-row>
      <el-table
        ref="defaultBottomFinishMappingList"
        v-loading="false"
        :data="items"
        border
        fit
        highlight-current-row
        style="width: 60%;margin: 0 auto"
      >
        <el-table-column :label="$t('defaultBottomFinishMapping.gomBottomFinish')" property="gomBottomSeam">
          <template slot-scope="scope">
            <span>{{ scope.row['gomBottomSeam'] }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>

          <el-table-column :label="$t('defaultBottomFinishMapping.webAtelierBottomFinish')">
            <template slot-scope="{ row }">
              <el-select
                v-model="row.webAtelierFinishCode"
                class="search-select"
                size="mini"
                type="select"
                clearable
                @input="handleFinishChange(row, $event)"
              >
                <el-option-group>
                  <el-option
                    v-for="finish in finishes"
                    :key="finish.code"
                    :label="finish.description"
                    :value="finish.code"
                  />
                </el-option-group>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import { entityToStore } from '@/utils/store';
import { closeCurrentTag } from '@/utils/tags';

export default {
  name: 'DefaultBottomFinishMappingList',
  components: {
    EditorButton
  },
  props: {
    entity: {
      default: 'DefaultBottomFinishMapping',
      type: String
    },
    permissionCode: String
  },
  data() {
    return {
      entityStoreName: entityToStore(this.entity),
      errorMsg: '',
      defaultCellAlign: 'left',
      items: [],
      finishes: []
    };
  },
  created() {
    this.$store.dispatch('defaultbottomfinishmapping/readWebAtelierFinishes', {}).then(data => {
      this.finishes = data.data;
    });
    this.refreshList();
  },
  methods: {
    handleFinishChange(row, finishCode) {
      if (finishCode !== '') {
        row.webAtelierFinishCode = finishCode;
        return;
      }
      row.webAtelierFinishCode = null;
    },
    refreshList() {
      this.$store.dispatch('defaultbottomfinishmapping/readMappings', {}).then(data => {
        this.items = data.data;
      });
    },
    saveSelection() {
      this.$store.dispatch('defaultbottomfinishmapping/saveMappings', this.items).then(() => {
        this.$store.dispatch('notify/success', { message: this.$i18n.t('common.data_updated') });
        this.refreshList();
      });
    },
    close() {
      closeCurrentTag(this);
    }
  }
};
</script>

<style lang="scss" scoped>
.mapping-table {
  .search-select {
    width: 100%;
    .el-input__inner {
      padding-left: 5px;
    }
    .el-input {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .el-input__suffix {
      top: -2px;
      right: 10px;
    }
  }
}
</style>
